const SHARED_STATUS_THEME = {
  canceled: { label: 'Canceled', color: 'grey-darken-4', variant: 'tonal' },
  paid: { label: 'Paid', color: 'success', variant: 'tonal' },
  processing: { label: 'Processing', color: 'purple', variant: 'tonal' },
};

const INVOICE_STATUS_THEME = {
  ...SHARED_STATUS_THEME,
  approved: { label: 'Approved', color: 'info', variant: 'tonal' },
  draft: { label: 'Draft', color: 'grey-darken-1', variant: 'outlined' },
  needs_review: { label: 'Needs review', color: 'error', variant: 'tonal' },
  paused: { label: 'Paused', color: 'warning', variant: 'tonal' },
};

const BILLING_STATEMENT_STATUS_THEME = {
  ...SHARED_STATUS_THEME,
  errored: { label: 'Errored', color: 'error', variant: 'tonal' },
  pending: { label: 'Pending', color: 'grey-darken-1', variant: 'outlined' },
};

const INVOICE_STATUS_OPTION_ORDER = [
  'draft',
  'approved',
  'canceled',
  'needs_review',
  'paused',
  'processing',
  'paid',
];

export const INVOICE_STATUSES = {
  APPROVED: 'approved',
  CANCELED: 'canceled',
  DRAFT: 'draft',
  NEEDS_REVIEW: 'needs_review',
  PAID: 'paid',
  PAUSED: 'paused',
  PROCESSING: 'processing',
};

function normalizeStatus(status) {
  return status?.toLowerCase() ?? '';
}

export const getStatusDisplayValue = (status) => {
  if (!status) return '';

  const normalized = normalizeStatus(status);
  return INVOICE_STATUS_THEME[normalized]?.label ?? status;
};

export const getInvoiceStatusPresentation = (status) => {
  const normalized = normalizeStatus(status);
  const theme = INVOICE_STATUS_THEME[normalized];
  return theme
    ? { color: theme.color, variant: theme.variant }
    : { color: 'grey', variant: 'tonal' };
};

export const getInvoiceStatusChipColor = (status) => getInvoiceStatusPresentation(status).color;

export const getInvoiceStatusChipVariant = (status) => getInvoiceStatusPresentation(status).variant;

export const INVOICE_STATUS_OPTIONS = INVOICE_STATUS_OPTION_ORDER.map((value) => ({
  value,
  text: INVOICE_STATUS_THEME[value].label,
}));

export const getBillingStatementStatusDisplayValue = (status) => {
  if (!status) return '';

  const normalized = normalizeStatus(status);
  return BILLING_STATEMENT_STATUS_THEME[normalized]?.label ?? status;
};

export const getBillingStatementStatusPresentation = (status) => {
  const normalized = normalizeStatus(status);
  const theme = BILLING_STATEMENT_STATUS_THEME[normalized];
  return theme
    ? { color: theme.color, variant: theme.variant }
    : { color: 'grey', variant: 'tonal' };
};

export const getBillingStatementStatusChipColor = (status) =>
  getBillingStatementStatusPresentation(status).color;

export const getBillingStatementStatusChipVariant = (status) =>
  getBillingStatementStatusPresentation(status).variant;
